import React from 'react';
import { Heart } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FinalCTA() {
  return <footer className="bg-brand-950 pt-24 pb-8 relative overflow-hidden" data-id="element-64">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-65"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-600 rounded-full blur-[120px] opacity-20 pointer-events-none" data-id="element-66"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-67">
        <FadeIn data-id="element-68">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-800 text-brand-400 mb-8" data-id="element-69">
            <Heart className="w-8 h-8 fill-brand-400" data-id="element-70" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-71">
            TU SALUD EMPIEZA CON LO QUE COMÉS
          </h2>

          <p className="text-xl text-brand-200 mb-10 max-w-2xl mx-auto" data-id="element-72">
            Empezá hoy una vida más saludable y organizada sin gluten
          </p>

          <a href="#oferta" className="inline-block w-full sm:w-auto px-10 py-5 bg-brand-500 hover:bg-brand-400 text-white rounded-2xl font-bold text-xl transition-all transform hover:scale-[1.02] shadow-[0_0_40px_-10px_rgba(59,163,102,0.5)] mb-20" data-id="element-73">
            QUIERO MI ALIMENTACIÓN SALUDABLE AHORA
          </a>
        </FadeIn>

        <div className="border-t border-brand-800/50 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-brand-400 text-sm" data-id="element-74">
          <p data-id="element-75">
            © {new Date().getFullYear()} Recetas Saludables para Celíacos.
            Todos los derechos reservados.
          </p>
          <div className="flex gap-4" data-id="element-76">
            <a href="#" className="hover:text-brand-200 transition-colors" data-id="element-77">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-brand-200 transition-colors" data-id="element-78">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}